import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2>Page not Found-404</h2>
            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        </div>
    );
};

export default NotFound;